(function () {
  var root = document.querySelector('.ogc-deal-pipeline-page');
  if (!root) return;

  /* Hero entrance sequence */
  var heroEls = root.querySelectorAll('.hero [data-hero-reveal]');

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      heroEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
    });
  });

  /* Existing scroll reveal */
  var els = root.querySelectorAll('[data-reveal]');

  if (!('IntersectionObserver' in window)) {
    els.forEach(function(el){
      el.classList.add('is-visible');
    });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  var carousel = root.querySelector('.testimonial-carousel');

  if (carousel) {
    var track = carousel.querySelector('.testimonial-scroll');
    var prev = carousel.querySelector('.tcard-nav.prev');
    var next = carousel.querySelector('.tcard-nav.next');

    if (track && prev && next) {
      function scrollAmount() {
        var card = track.firstElementChild;
        var gap = 20;
        return card ? card.offsetWidth + gap : track.clientWidth * 0.8;
      }

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({
          left: -scrollAmount(),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', function () {
        track.scrollBy({
          left: scrollAmount(),
          behavior: 'smooth'
        });
      });

      track.addEventListener('scroll', updateButtons, {
        passive: true
      });

      window.addEventListener('resize', updateButtons);
      updateButtons();
    }
  }

  if (window.lucide) {
    window.lucide.createIcons();
  }
})();